import React from 'react'
import css from './style.scss'
import {FullPage} from 'components/container';
import {connect} from 'react-redux'
import DataSection from './data_section'
import SubscriptionSection from './subscription_section'

class SettingsPage extends React.Component{
  render(){
    return (
      <FullPage withContainer>
        <h3>Your Settings</h3>
        <div className={css.settings}>
          <DataSection user={this.props.user}/>
          <SubscriptionSection user={this.props.user}/>
        </div>
      </FullPage>
    )
  }
}

const mapStateToProps=(state)=>{
  return {
    user:state.user.userData
  }
}
export default connect(mapStateToProps)(SettingsPage);



// WEBPACK FOOTER //
// ./src/components/settings/index.js